import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

/**
 * Hide element when printing (Ctrl+P)
 */
export const hiddenOnPrint: SystemStyleObject<Theme> = {
  "@media print": {
    display: "none",
  },
};

/**
 * Show element only when printing
 */
export const visibleOnlyOnPrint: SystemStyleObject<Theme> = {
  display: "none",
  "@media print": {
    display: "block",
  },
};

/**
 * For flex containers - show only when printing
 */
export const visibleOnlyOnPrintFlex: SystemStyleObject<Theme> = {
  display: "none",
  "@media print": {
    display: "flex",
  },
};

/**
 * Print-friendly page layout - removes backgrounds, adjusts spacing
 */
export const printFriendlyPage: SystemStyleObject<Theme> = {
  "@media print": {
    backgroundColor: "white",
    padding: "0",
    margin: "0",
    overflow: "visible",
    height: "auto",
  },
};

/**
 * Removes height/overflow constraints so content flows across print pages
 */
export const printOverflowVisible: SystemStyleObject<Theme> = {
  "@media print": {
    height: "auto !important",
    overflow: "visible !important",
  },
};
